import React, { useContext, useEffect, useState } from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import { EasybakeContext } from '../EasybakeProvider'
import Heading from '@react/react-spectrum/Heading'
import Well from '@react/react-spectrum/Well'
import FieldLabel from '@react/react-spectrum/FieldLabel'
import Select from '@react/react-spectrum/Select'
import CreateNewCredentialsButton from '../Nav/CreateNewCredentialsButton'
import SampleCodeButton from '../Nav/SampleCodeButton'
import LinkButton from '../Nav/LinkButton'
import { setBodyHeight, logAlert, logAlertMissingRole } from '../../lib/easybake'
import analytics from '../../config/analytics'
import { getIntegrations, getOrgs, getProject, getClientSecret} from '../../lib/consoleApi'
import {
    STATUS_CODE_SUCCESS_OK
} from '../../lib/constants'

export default function GetStarted () {
    const { ut, userOrgs, userOrgsInts, page, dispatch } = useContext(EasybakeContext)
    const [ consoleUrl, setConsoleUrl ] = useState(null)

    useEffect(() => {
        if (ut) {
            getUserOrgs()
        }
        setBodyHeight()
    }, [ut])

    async function getUserOrgs() {
        try {
            const orgs = await getOrgs(ut)
            if (orgs && orgs.error) {
                throw new Error(orgs.error)
            } else {
                dispatch({ type: 'set-userOrgs', payload: { userOrgs: orgs.response } })
                getOrgIntegrations(orgs.response)
            }
        } catch(e) {
            if (e.message && e.message === __('console_create_error_org_not_found')) {
                logAlertMissingRole(e, page)
            } else {
                logAlert(e)
            }
            analytics.sendEventName('click', `${page}:getuserorgs:error`)
        }
    }

    async function getOrgIntegrations(orgs) {
        try {
            const selectedUserOrg = orgs.data.filter( org => org.selected)[0]
            const ints = await getIntegrations(selectedUserOrg.id, ut)
            if ( ints && ints.response && ints.response && ints.response.length > 0) {
                const intsArray = []
                ints.response.forEach(content => {
                    if (content.sdkList && content.sdkList.length === 1 && content.sdkList.includes('CIS SDK')) {
                        intsArray.push(content)
                    }
                })
                dispatch({ type: 'set-userOrgsInts', payload: { userOrgsInts: intsArray } })
            }
        } catch(e) {
            logAlert(e)
            analytics.sendEventName('click', `${page}:getuserorgs:error`)
        }
    }

    function signInClick() {
        if (window.easybake) {
            analytics.sendEventName('click', `${page}:signin`)
            window.easybake.parent.signIn()
        }
    }

    function getUserOrgsSelectionValue (e) {
        try {
            if (userOrgs && userOrgs.data.length > 0) {
                const selectValue = userOrgs.data.find( org => org.selected === true)
                return selectValue && selectValue.value || null
            }
        } catch(e) {
            logAlert(e)
        }
    }

    async function getConsoleUrl (orgInts) {
        try {
            if (orgInts && orgInts.length > 0) {
                const selectValue = orgInts.find( integration => integration.selected === true)
                if (selectValue) {
                    const project = await getProject(selectValue.orgId, selectValue.name, ut)
                    if (project && project.status === STATUS_CODE_SUCCESS_OK) {
                        setConsoleUrl(`${process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT}/console/projects/${getUserOrgsSelectionValue()}/${project.id}/overview`)
                        dispatch({ type: 'set-projectName', payload: { projectName: project.name } })
                        const secret = await getClientSecret(selectValue.orgId, selectValue.id, ut)
                        if (secret && secret.data.client_secrets.length > 0 && secret.status === STATUS_CODE_SUCCESS_OK) {
                            const cred = {
                                apiKey: selectValue.apiKey,
                                orgId: selectValue.orgId,
                                organization: selectValue.orgId,
                                project: project,
                                projectName: project.name,
                                projectId: project.id,
                                intId: selectValue.id,
                                clientSecret: secret.data.client_secrets[0],
                                status: secret.status
                            }
                            dispatch({ type: 'set-cred', payload: { cred: cred } })
                        }
                    }
                }
            }
        } catch(e) {
            logAlert(e)
        }
    }

    function changeUserOrgsSelection (e) {
        try {
            const newUserOrgsData = userOrgs.data.map( option => {
                if (option.value === e) {
                    option.selected = true
                } else {
                    option.selected = false
                }
                return option
            })
            userOrgs.data = newUserOrgsData
            dispatch({ type: 'set-userOrgs', payload: { userOrgs: userOrgs } })
            getOrgIntegrations(userOrgs)
        } catch(e) {
            logAlert(e)
        }
    }

    function changeUserOrgsIntsSelection (e) {
        try {
            const newIntegrations = [];
            userOrgsInts.forEach( integration => {
                if (integration.value === e) {
                    integration.selected = true
                } else {
                    integration.selected = false
                }
                newIntegrations.push(integration)
            })
            dispatch({ type: 'set-userOrgsInts', payload: { userOrgsInts: newIntegrations } })
            getConsoleUrl(newIntegrations)
        } catch(e) {
            logAlert(e)
        }
    }

    function isDisabled() {
        if (!userOrgs || userOrgs && userOrgs.length === 0) {
            return true
        }
    }

    function isIntButtonDisabled () {
        if (!userOrgsInts) {
            return true
        }
        if (userOrgsInts && userOrgsInts.length === 0) {
            return true
        }
        const selectedInt = userOrgsInts.filter( int => int.selected)
        if (!selectedInt || selectedInt && selectedInt.length === 0) {
            return true
        }
        return false
    }

    function goToConsole() {
        try {
            analytics.sendEventName('click', `${page}:gotoioconsole`)
            const orgId = referrer && referrer.orgId
            const projectId = referrer && referrer.projectId
            goToUrlTarget(encodeURI(`${process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT}/console/projects/${orgId}/${projectId}/overview`), '_blank')
        } catch(e) {
            logAlert(e)
        }
    }

    return <div className="adobe-easybake-main-pane-full">
        <div className="adobe-easybake-main adobe-easybake-home">
            <div className="adobe-easybake-home-content">
                <div className="adobe-easybake-main-sub-pane-contents-signup">
                    <div className="adobe-easybake-main-sub-pane-header">
                        <Heading variant="pageTitle" className="adobe-easybake-console-title">{__('console_get_started_title')}</Heading>
                        <br />
                        <p>{__('console_get_started_desc')}</p>
                        { !ut && <div>Please <a href="#" onClick={ e => signInClick(e) }>sign in</a> to continue.</div>}
                        <br />
                    </div>
                    <div className="adobe-easybake-main-contents">
                        <div className="adobe-easybake-flex-row-space-between">
                            <div className="adobe-easybake-flex-row-contents">
                                <Well className="adobe-easybake-well-card adobe-easybake-well-card-get-started">
                                    <div className="adobe-easybake-split-vertical">
                                        <div>
                                            <Heading variant="subtitle1">{__('console_get_started_create_title')}</Heading>
                                            <div className="adobe-easybake-well-body">{__('console_get_started_create_desc')}</div>
                                        </div>
                                        <div>
                                            <hr className="adobe-easybake-hr"/>
                                            <div className="adobe-easybake-well-card-button">
                                                <CreateNewCredentialsButton referrer={page} />
                                            </div>
                                        </div>
                                    </div>
                                </Well>
                            </div>
                            <div className="adobe-easybake-flex-row-contents">
                                <Well className="adobe-easybake-well-card adobe-easybake-well-card-get-started">
                                    <div className="adobe-easybake-split-vertical">
                                        <div>
                                            <Heading variant="subtitle1">{__('console_get_started_manage_title')}</Heading>
                                            <div className="adobe-easybake-well-body">{__('console_get_started_manage_desc')}</div>
                                            <br />
                                            { (userOrgs && userOrgs.data && userOrgs.data.length > 1) &&
                                                <div>
                                                    <FieldLabel necessity="required" label={`Organization (${userOrgs.data.length})`} labelFor="tf-userOrgs">
                                                        <Select
                                                            aria-label="tf-userOrgs"
                                                            label="userOrgs"
                                                            defaultValue={getUserOrgsSelectionValue()}
                                                            onChange={ e => changeUserOrgsSelection(e) }
                                                            disabled={ userOrgs && userOrgs.data && userOrgs.data.length===0}
                                                            options={ userOrgs.data } />
                                                    </FieldLabel>
                                                </div>
                                            }
                                            { (userOrgsInts && userOrgsInts.length > 0) &&
                                                <div>
                                                    <FieldLabel necessity="required" label={`Credentials (${userOrgsInts.length})`} labelFor="tf-userOrgs">
                                                        <Select
                                                            aria-label="tf-userOrgs"
                                                            label="userOrgs"
                                                            options={ userOrgsInts }
                                                            placeholder={__('console_create_org_select_option')}
                                                            onChange={ e => changeUserOrgsIntsSelection(e) }
                                                            disabled={ isDisabled() } />
                                                    </FieldLabel>
                                                </div>
                                            }
                                        </div>
                                        <div>
                                            <hr className="adobe-easybake-hr"/>
                                            <div className="adobe-easybake-well-card-button">
                                                <SampleCodeButton referrer={page} isDisabled={ isIntButtonDisabled() } />
                                                <LinkButton referrer={page} url={consoleUrl} target="_blank" isDisabled={ isIntButtonDisabled() }/>
                                            </div>
                                        </div>
                                    </div>
                                </Well>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
